import type { Media } from '@/types/media';

interface PlayModalProps {
  item: Media;
  open: boolean;
  onClose: () => void;
}

export default function PlayModal({ item, open, onClose }: PlayModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-primary-950/80 px-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl overflow-hidden rounded-lg bg-background-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between bg-primary-950 px-4 py-3">
          <div className="flex items-center gap-2">
            <i className="ri-play-circle-line text-lg text-accent-400" />
            <span className="text-sm font-semibold text-background-50">
              {item.title} · 演示播放
            </span>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-background-200 transition-colors hover:bg-primary-900"
            aria-label="关闭"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="relative flex aspect-video w-full items-center justify-center bg-foreground-950">
          <img
            src={item.cover}
            alt={item.title}
            className="absolute inset-0 h-full w-full object-top opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-3 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-play-fill text-3xl" />
            </span>
            <p className="text-sm font-medium text-background-100">演示播放功能</p>
            <p className="max-w-xs text-xs text-background-300">
              当前为前端播放界面演示，真实播放需后续接入视频源
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4 bg-foreground-900 px-4 py-3 text-background-200">
          <i className="ri-play-fill text-lg" />
          <div className="h-1 flex-1 overflow-hidden rounded-full bg-background-50/20">
            <div className="h-full w-1/3 rounded-full bg-accent-500" />
          </div>
          <span className="text-xs">00:00 / --:--</span>
          <i className="ri-volume-up-line text-lg" />
          <i className="ri-fullscreen-line text-lg" />
        </div>
      </div>
    </div>
  );
}